import timePeriodList from "./time-period";
import revisionNumberList from "./revision-number";

export default [...timePeriodList, ...revisionNumberList];
